{
  "adminSignInLink": {
    "body": "Haz clic en el botón de abajo para acceder a tu portal de administración de Pointcare.",
    "cta": "Iniciar sesión en administración",
    "greeting": "Hola,",
    "ignore": "Si no solicitaste acceso de administración, puedes ignorar este correo.",
    "linkFallback": "Si el botón no funciona, copia y pega este enlace:",
    "signoff": "Gracias,\nEl equipo de Pointcare",
    "subject": "Tu enlace de inicio de sesión de administración de Pointcare"
  },
  "reset": {
    "body": "Recibimos una solicitud para restablecer la contraseña de tu cuenta de Pointcare. Haz clic en el botón de abajo para crear una nueva.",
    "cta": "Restablecer mi contraseña",
    "greeting": "Hola,",
    "ignore": "Si no solicitaste esto, puedes ignorar este correo de forma segura. Tu contraseña no cambiará.",
    "signoff": "Gracias,\nEl equipo de Pointcare",
    "subject": "Restablece tu contraseña de Pointcare"
  },
  "signInLink": {
    "body": "Toca el botón de abajo para confirmar tu correo electrónico y configurar tu cuenta de Pointcare.",
    "cta": "Confirmar mi correo",
    "greeting": "Hola,",
    "ignore": "¿No te registraste en Pointcare? Puedes ignorar este correo.",
    "linkFallback": "Si el botón no funciona, copia y pega este enlace:",
    "signoff": "Gracias,\nEl equipo de Pointcare",
    "subject": "Confirma tu correo electrónico para Pointcare"
  }
}
